import React from "react";
import { default as WList } from "@mui/material/List";

function List(props) {
  return <WList {...props} />;
}

export default List;
